export default __webpack_public_path__ + "static/media/question-bank.5396e1a6.svg";